// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"271b75ac","223":"88abcafd","864":"15a7b154","887":"d2221087","897":"f622deb9","916":"f86f4830","932":"3177d184"}[chunkId] + ".css";
};